module.exports = __webpack_public_path__ + "img/fashion_102.7598a869.jpg";